//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      youtubeId: null
    };
  },
  computed: {
    compiledText: function compiledText() {
      return Utils.format.markdown(this.spec.text);
    }
  },
  methods: {
    $ready: function $ready() {
      if (this.spec.previewVideo) {
        this.youtubeId = this.extractYoutubeId(this.spec.text);
        console.log("Detected Youtube ID", this.youtubeId);
      } // Set all links to be openWeb or open in a new tab by default


      if (!this.spec.openWeb) {
        var anchors = document.querySelectorAll("a");

        for (var i = 0; i < anchors.length; i++) {
          anchors[i].setAttribute("target", "_blank");
        }
      }
    },
    // From https://gist.github.com/takien/4077195
    extractYoutubeId: function extractYoutubeId(url) {
      var ID = "";
      url = url.replace(/(>|<)/gi, "").split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);

      if (url[2] !== undefined) {
        ID = url[2].split(/[^0-9a-z_\-]/i);
        ID = ID[0];
      }

      return ID;
    }
  }
};